import { EntityMetadata, HttpResourceUrls } from '@ngrx/data';
import { Appointment } from '../../appointments/state/appointment.model';

export interface DateAppointmentQueryFilter {
    requestType?: string; // This will tell which type of request needs to be called - remoteappointment, appointment, reminderreport
    remoteAppointmentId?: number;
    appointmentId?: number;
    date?: string;
    offset?: number;
    totalLoaded: number;
    batchSize: number;
    lastUpdated: number;
}

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const dateAppointmentEntityMetadata: EntityMetadata<Appointment> = {
    entityName: 'DateAppointment',
    selectId: dateAppointmentSelectId, // .id is used if doing optimistic update
    additionalCollectionState: {
        refreshing: false,
        queryFilter: {
            date: new Date(),
            offset: 0,
            totalLoaded: 0,
            lastUpdated: undefined,
            batchSize: undefined
        }
    }
    // https://stackoverflow.com/questions/62828590/how-to-extend-custom-entity-collection-reducers-in-ngrx-data

    // filterFn: nameFilter,
    // sortComparer: sortByName
    // entityDispatcherOptions: { optimisticAdd: true, optimisticUpdate: true }
};

export const dateAppointmentHttpResourceUrls: HttpResourceUrls = {
    entityResourceUrl : '/servlets/ngappointment/entity/', // Not used
    collectionResourceUrl: '/servlets/ngappointments/entities/' // Not used
};

// tslint:disable-next-line:only-arrow-functions typedef
export function dateAppointmentSelectId<T extends { id: any }>(appointment: Appointment) {
    return  appointment === undefined ? undefined : appointment.id || appointment.appointmentId;  // .id is used if doing optimistic update
}
